<script setup lang="ts">
/**
 * Multi-step form progress indicator: numbered circles connected by a line.
 *
 * Passed steps + the current step are filled green (--color-success) with a
 * white number; future steps are white circles with a gray outline and gray
 * number. The connecting line is green up to the current step and gray
 * beyond it.
 */
const props = defineProps<{
  current: number
  total?: number
}>()

const total = computed(() => props.total ?? 5)
</script>

<template>
  <div class="flex items-center">
    <template v-for="i in total" :key="i">
      <div
        v-if="i > 1"
        class="h-[2px] flex-1 transition-colors"
        :class="i <= current ? 'bg-success' : 'bg-border'"
      />
      <div
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors"
        :class="
          i <= current
            ? 'bg-success text-white'
            : 'border-2 border-border bg-white text-text/70'
        "
        :aria-current="i === current ? 'step' : undefined"
      >
        {{ i }}
      </div>
    </template>
  </div>
</template>
